import React from 'react';

const TechStackPartners = () => {
  const techStack = [
    'React', 'React Native', 'Node.js', 'Vue.js', 'Angular', 'TypeScript', 'Flutter', 'Swift', 'Kotlin', 'Java (Android)', 'Firebase', 'Expo', 'Redux', 'Next.js', 'Express.js', 'Tailwind CSS', 'Sass', 'GraphQL', 'MongoDB', 'PostgreSQL'
  ];

  // Use the external URLs from manifest.json
  const logoManifest = {
    "React": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    "React Native": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    "Node.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    "Vue.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
    "Angular": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
    "TypeScript": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    "Flutter": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    "Swift": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg",
    "Kotlin": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg",
    "Java (Android)": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
    "Firebase": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
    "Expo": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/expo/expo-original.svg",
    "Redux": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
    "Next.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
    "Express.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
    "Tailwind CSS": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
    // If the above is not visible, try the colored version:
    // "Tailwind CSS": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
    "Sass": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg",
    "GraphQL": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
    "MongoDB": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    "PostgreSQL": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg"
  };
  const partners = ['AWS Partner', 'Google Cloud Partner', 'MongoDB Atlas', 'Firebase', 'Stripe', 'Twilio'];

  const industries = [
    { name: 'E-Commerce', icon: '🛍️', description: 'Scalable shopping platforms with AI recommendations' },
    { name: 'Healthcare', icon: '⚕️', description: 'HIPAA-compliant telemedicine and patient management' },
    { name: 'FinTech', icon: '💰', description: 'Real-time financial dashboards and trading platforms' },
    { name: 'EdTech', icon: '📚', description: 'Interactive learning platforms with video streaming' },
    { name: 'Real Estate', icon: '🏠', description: 'Virtual tours and property management systems' },
    { name: 'Food & Delivery', icon: '🍕', description: 'On-demand delivery with real-time tracking' }
  ];

  return (
    <>
      <section id="tech-stack">
        <div className="section-header">
          <h2 className="section-title">Technology Stack</h2>
          <p className="section-subtitle">We master the latest and most reliable technologies</p>
        </div>
        <div className="tech-stack-grid">
          {techStack.map((tech, index) => (
            <div className="tech-item fade-in" key={index} style={{animationDelay: `${(index % 5) * 0.1}s`}}>
              <img
                className="tech-icon"
                src={logoManifest[tech] || '/tech-logos/default.svg'}
                alt={tech + ' logo'}
                style={{ width: 36, height: 36, objectFit: 'contain', background: 'transparent', display: 'block', margin: '0 auto' }}
                loading="lazy"
              />
              <p>{tech}</p>
            </div>
          ))}
        </div>
      </section>



      {/* Industries We Serve section removed as requested */}
    </>
  );
};

export default TechStackPartners;
